import { useTranslate } from "ra-core";

import { cn } from "@/lib/utils";

import {
  grupoLlamada,
  momentoReintento,
  textoMomento,
} from "../dominio/llamadas";
import type { Negocio } from "../dominio/tipos";

/**
 * Próximo intento en Leads (46, auditoría 30/10/2026): «Llamar ya» si llegó por la web sin
 * llamar o el reintento ya ha vencido; la hora si aún no toca; nada si es una ficha nueva.
 */
export const ProximoIntento = ({
  negocio,
  ahora = new Date(),
}: {
  negocio: Negocio;
  ahora?: Date;
}) => {
  const translate = useTranslate();
  const grupo = grupoLlamada(negocio, ahora);
  const momento = momentoReintento(negocio);
  if (grupo === 0 || grupo === 1)
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1.5 text-xs font-medium",
          "text-[#336394] dark:text-[#6FA0D6]",
        )}
        title={
          momento
            ? translate("nevora.llamadas.vencido", {
                momento: textoMomento(momento, ahora, translate),
              })
            : undefined
        }
        data-testid="llamar-ya"
      >
        <span className="size-1.5 rounded-full bg-[#3D8BD4]" aria-hidden />
        {translate("nevora.llamadas.llamar_ya")}
      </span>
    );
  if (grupo === 4 && momento)
    return (
      <span className="text-xs text-muted-foreground tabular-nums">
        {textoMomento(momento, ahora, translate)}
      </span>
    );
  return <span className="text-xs text-muted-foreground">—</span>;
};
